import type { ReactNode } from "react";
import { Badge } from "./components";
import DataCoverageLayout from "./layout";

const rows = [
  { market: "FOREX", historical: "Y", delayed: "N/A", realTime: "Y", level2: "N" },
  { market: "Spot Metals", historical: "Y", delayed: "N/A", realTime: "Y", level2: "N" },
  { market: "Binance", historical: "Y", delayed: "N/A", realTime: "Y", level2: "Y" },
  { market: "Bitfinex", historical: "Y", delayed: "N/A", realTime: "Y", level2: "Y" },
  { market: "Bithumb", historical: "Y", delayed: "N/A", realTime: "Y", level2: "N" },
  { market: "Bitmex", historical: "Y", delayed: "N/A", realTime: "Y", level2: "N" },
  { market: "Bitstamp", historical: "Y", delayed: "N/A", realTime: "Y", level2: "Y" },
  { market: "Bittrex", historical: "Y", delayed: "N/A", realTime: "Y", level2: "N" },
  { market: "Cex.io", historical: "Y", delayed: "N/A", realTime: "Y", level2: "Y" },
  { market: "Cobinhood", historical: "Y", delayed: "N/A", realTime: "Y", level2: "Y" },
  { market: "gate.io", historical: "Y", delayed: "N/A", realTime: "Y", level2: "N" },
  { market: "GDAX (Coinbase Pro)", historical: "Y", delayed: "N/A", realTime: "Y", level2: "Y" },
  { market: "Gemini", historical: "Y", delayed: "N/A", realTime: "N", level2: "N" },
  { market: "HitBtc", historical: "Y", delayed: "N/A", realTime: "Y", level2: "N" },
  { market: "Huobi", historical: "Y", delayed: "N/A", realTime: "Y", level2: "Y" },
  { market: "Kucoin", historical: "Y", delayed: "N/A", realTime: "Y", level2: "N" },
  { market: "LBank", historical: "Y", delayed: "N/A", realTime: "Y", level2: "Y" },
  { market: "OKCoin", historical: "Y", delayed: "N/A", realTime: "Y", level2: "N" },
  { market: "OkEx", historical: "Y", delayed: "N/A", realTime: "Y", level2: "N" },
  { market: "Poloniex", historical: "Y", delayed: "N/A", realTime: "N", level2: "N" },
  { market: "Wex.nz (BTC-e)", historical: "Y", delayed: "N/A", realTime: "N", level2: "N" },
  { market: "Kraken", historical: "Y", delayed: "N/A", realTime: "Y", level2: "N" },
  { market: "BXINTH", historical: "Y", delayed: "N/A", realTime: "Y", level2: "N" },
  { market: "Korbit", historical: "Y", delayed: "N/A", realTime: "Y", level2: "N" },
  { market: "ErisX", historical: "N", delayed: "N/A", realTime: "Y", level2: "N" },
  { market: "Seedcx", historical: "Y", delayed: "N/A", realTime: "Y", level2: "N" },
  { market: "Trade.io", historical: "Y", delayed: "N/A", realTime: "Y", level2: "Y" },
];

export default function CryptoPage(): ReactNode {
  return (
    <DataCoverageLayout>
      <div className="overflow-x-auto">
        <table className="w-full text-sm border-collapse">
          <thead>
          <tr className="border-b border-gray-200">
            {["Market", "Historical", "Delayed", "Real Time", "Level 2"].map(h => (
              <th key={h} className="text-left py-2 px-3 text-xs font-semibold text-gray-500 uppercase tracking-wide whitespace-nowrap">{h}</th>
            ))}
          </tr>
          </thead>
          <tbody>
          {rows.map(({ market, historical, delayed, realTime, level2 }) => (
            <tr key={market} className="border-b border-gray-100 hover:bg-gray-50">
              <td className="py-2 px-3 font-medium text-gray-800 whitespace-nowrap">{market}</td>
              <td className="py-2 px-3"><Badge value={historical}/></td>
              <td className="py-2 px-3"><Badge value={delayed}/></td>
              <td className="py-2 px-3"><Badge value={realTime}/></td>
              <td className="py-2 px-3"><Badge value={level2}/></td>
            </tr>
          ))}
          </tbody>
        </table>
      </div>
    </DataCoverageLayout>
  );
}
